// extracted by mini-css-extract-plugin
module.exports = {"PopupControlPanel":"PopupControlPanel_PopupControlPanel__1_iIx","spinnerArea":"PopupControlPanel_spinnerArea__32b99"};